import { EntityChip } from "@circle-react-shared/EditorContentBlocks/EntityChip";
import { getEntityContent } from "@circle-react-uikit/TipTap/Extensions/CustomExtensions/Entities/helpers";
import { entityHref } from "@circle-react/helpers/urlHelpers/entitiesPaths";
import { useElectronAPI } from "@circle-react/hooks/utils/useElectronAPI";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import type { EntityObject } from "./types";

interface StaticEntityProps {
  entity?: EntityObject;
}

export const StaticEntity = ({ entity }: StaticEntityProps) => {
  const { navigateToUrl, isElectron } = useElectronAPI();

  if (!entity) {
    return (
      <TippyV2
        interactive={false}
        content={t("unavailable_entity_message")}
        placement="top"
      >
        <span className="text-circle mx-0.5 cursor-pointer rounded-sm bg-indigo-100 px-0.5 font-medium">
          {t("unavailable_entity")}
        </span>
      </TippyV2>
    );
  }

  const redirectToEntity = (path?: string) => {
    if (!path) {
      return;
    }

    if (isElectron) {
      void navigateToUrl(path);
    } else {
      window.open(path, "_blank", "noreferrer");
    }
  };

  const isSpaceEntity = entity.type === "space" || entity.type === "Space";
  const entityContent = getEntityContent(entity);
  const href = entityHref(entity);

  return (
    <TippyV2
      interactive={false}
      content={entityContent}
      placement="top"
      disabled={!entityContent}
    >
      <EntityChip
        onClick={() => redirectToEntity(href)}
        isSpace={isSpaceEntity}
        name={entity.name || t("tiptap.entity_untitled")}
      />
    </TippyV2>
  );
};
